var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgBrowse = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 38,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A202C",
    d: "M40.833 11.667c-.145 0-.291.029-.437.087L28 16.334l-.751-.263c1.699-2.545 3.084-5.192 3.084-7.102C30.333 4.01 26.155 0 21 0s-9.333 4.018-9.333 8.969c0 .86.291 1.881.758 2.96L1.465 15.75A2.332 2.332 0 000 17.916v18.25a1.165 1.165 0 001.604 1.08L14 32.666l12.542 4.427c.948.313 1.968.32 2.916.014l11.076-3.857A2.327 2.327 0 0042 31.084v-18.25c0-.671-.547-1.167-1.167-1.167zm-28 18.943L2.326 34.49l-.095-16.545 10.602-3.683V30.61zM21 2.333c3.857 0 7 2.975 7 6.636 0 1.969-2.778 6.482-7 11.433-4.222-4.951-7-9.465-7-11.433 0-3.66 3.143-6.636 7-6.636zm5.833 32.39l-11.666-4.12v-13.92c1.779 2.574 3.799 4.959 4.936 6.25.233.27.569.4.897.4.328 0 .656-.13.897-.4a76.96 76.96 0 003.96-4.879l.976.343v16.326zm2.334.014V18.39l10.507-3.88.095 16.545-10.602 3.682zM22.75 9.333a1.75 1.75 0 00-3.5 0c0 .963.788 1.75 1.75 1.75s1.75-.78 1.75-1.75z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBrowse, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/browse.59d52750.svg";
export { ForwardRef as ReactComponent };